/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ModalConfirm } from "@nordcloud/gnui";
import { useRemoveReport } from "~/views/resources/hooks";

type Props = {
  reportId: string;
  reportName: string;
  isDeleteModalOpen: boolean;
  close: () => void;
};

export function DeleteModal({
  reportId,
  reportName,
  isDeleteModalOpen,
  close,
}: Props) {
  const [removeReport] = useRemoveReport({
    reportName: reportName,
  });

  const onDelete = () => {
    removeReport(reportId);
    close();
  };

  return (
    <ModalConfirm
      onClose={close}
      isOpen={isDeleteModalOpen}
      confirm={onDelete}
      actionLabel="Delete"
      data-testid="modal-delete-report"
      contentLabel={`Delete Report`}
    >
      {`Are you sure you want to delete ${reportName}?`}
    </ModalConfirm>
  );
}
